(function () {
    'use strict';

    a3_cabin_reports.factory('DataCleanerFactory', DataCleanerFactory);

    /**
     * @memberof CabinReports
     * @ngdoc factory
     * @name DataCleanerFactory
     * @description 
     *   Cleans the Data of the application
     * @ngInject
     */
    function DataCleanerFactory(localStorageMD5Service, IndexedDBService, GenericService) {


        var service = {
            deleteAllReports: deleteAllReports,
            deleteAllServerData: deleteAllServerData,
            deleteAllData: deleteAllData,
            deleteOrphanedLocalFlights: deleteOrphanedLocalFlights,
            deleteOrphanedLocalReports: deleteOrphanedLocalReports,
            deleteSynchedLocalCabinReports: deleteSynchedLocalCabinReports,
            deleteIndexedDB: deleteIndexedDB,
            deleteOldCrewMealsRatings:deleteOldCrewMealsRatings,
            deleteOrphanedCustomerEvents:deleteOrphanedCustomerEvents
        }
        /**
         * Delete All Cabin Reports
         * @memberof DataCleanerFactory
         */
        function deleteAllReports() {
            localStorageMD5Service.remove('cabinReportLocalEdits');
            localStorageMD5Service.remove('cabinReportLocalEdit_TEMP');
            deleteOrphanedLocalFlights();
        };

        /**
         * Delete Basic Server data
         * @memberof DataCleanerFactory
         */
        function deleteAllServerData() {
            localStorageMD5Service.remove('flights');
            localStorageMD5Service.remove('reportGuids');
            localStorageMD5Service.remove('aircraftTypes');
            localStorageMD5Service.remove('cabinReportTemplateItems');
            localStorageMD5Service.remove('cabinReportSyncResults');
            localStorageMD5Service.remove('assessmentSyncResults');
            localStorageMD5Service.remove('waterUpliftActions');
            localStorageMD5Service.remove('acSupplies');
            localStorageMD5Service.remove('specialMealSources');
            localStorageMD5Service.remove('specialMealTypes');
            localStorageMD5Service.remove('currencies');
            localStorageMD5Service.remove('travelValueIncompleteReasons');
            localStorageMD5Service.remove('incompleteInFlightServiceListOfValues');
            localStorageMD5Service.remove('ccms');
            localStorageMD5Service.remove('scheduleChanges');
            localStorageMD5Service.remove('CheckIn');
            localStorageMD5Service.remove('flightCheckIns');

            localStorageMD5Service.remove('CrewAssessmentTemplate');
            localStorageMD5Service.remove('FAQItem');
            localStorageMD5Service.remove('PaxInfo');

            localStorageMD5Service.remove('flightEventTypes');
            localStorageMD5Service.remove('flightEvents');
            deleteOrphanedLocalFlights();
        };

        /**
         * Delete All Server data
         * @memberof DataCleanerFactory
         */
        function deleteAllData() {
            localStorageMD5Service.clearAll();

            IndexedDBService.deleteDatabase();
        };

        function deleteIndexedDB() {
            
          return IndexedDBService.deleteDatabase();
        }


        /**
         * Delete local flights that have no stored local reports
         * @memberof DataCleanerFactory
         */
        function deleteOrphanedLocalFlights() {

            var existingLocalFlights = localStorageMD5Service.get('localFlights');
            if (existingLocalFlights == null)
                return;

            var finalLocalFlights = [];

            var cabinReportLocalEdits = localStorageMD5Service.get('cabinReportLocalEdits');
            if (cabinReportLocalEdits == null)
                cabinReportLocalEdits = [];

            // check every local flight that has a saved cabin report
            for (var i = 0; i < existingLocalFlights.length; i++) {
                var hasCabinReport = false;

                for (var j = 0; j < cabinReportLocalEdits.length; j++) {
                    if ((cabinReportLocalEdits[j].FlightId != null && cabinReportLocalEdits[j].FlightId == existingLocalFlights[i].FlightId) || (cabinReportLocalEdits[j].FlightAimsId != null && cabinReportLocalEdits[j].FlightAimsId == existingLocalFlights[i].FlightAimsId)) {
                        hasCabinReport = true;
                        break;
                    }
                }
                // if it has a cabin report, add it to the flights to save
                if (hasCabinReport)
                    finalLocalFlights.push(existingLocalFlights[i]);
            }
            // save the resulting local flights
            localStorageMD5Service.set('localFlights', finalLocalFlights);
        }

        /**
         * Delete local reports that have no stored local flights
         * @memberof DataCleanerFactory
         */
        function deleteOrphanedLocalReports() {
            var existingLocalCabinReports = localStorageMD5Service.get('cabinReportLocalEdits');
            var flights = localStorageMD5Service.get('flights');

            if (existingLocalCabinReports == null || flights == null || existingLocalCabinReports.length == 0 || flights.length == 0)
                return 0;

            var finalLocalCabinReports = [];
            for (var i = 0; i < existingLocalCabinReports.length; i++) {
                var remove = false;

                if (existingLocalCabinReports[i].Status == 'synched') {
                    remove = true;
                    if (existingLocalCabinReports[i].FlightId != null || existingLocalCabinReports[i].FlightAimsId != null) {
                        for (var j = 0; j < flights.length; j++) {
                            if (
                                (existingLocalCabinReports[i].FlightId != null && existingLocalCabinReports[i].FlightId == flights[j].FlightId) || (existingLocalCabinReports[i].FlightAimsId != null && existingLocalCabinReports[i].FlightAimsId == flights[j].FlightAimsId)
                            ) {
                                remove = false;
                            }
                        }
                    }
                }
                if (!remove)
                    finalLocalCabinReports.push(existingLocalCabinReports[i]);
            }
            // save the resulting local reports
            localStorageMD5Service.set('cabinReportLocalEdits', finalLocalCabinReports);
        }

        /**
         * Delete  Synched Local CabinReports
         * @memberof DataCleanerFactory
         */
        function deleteSynchedLocalCabinReports() {

            var existingLocalCabinReports = localStorageMD5Service.get('cabinReportLocalEdits');
            var flights = localStorageMD5Service.get('flights');

            if (existingLocalCabinReports == null || flights == null || existingLocalCabinReports.length == 0 || flights.length == 0)
                return 0;

            var finalLocalCabinReports = [];
            var deleted = 0;

            var user = localStorageMD5Service.get('user');;
            // check every saved cabin report
            for (var i = 0; i < existingLocalCabinReports.length; i++) {

                var remove = false;

                if (existingLocalCabinReports[i].Status == 'synched') {
                    if (existingLocalCabinReports[i].FlightId != null || existingLocalCabinReports[i].FlightAimsId != null) {
                        for (var j = 0; j < flights.length; j++) {
                            if (
                                (existingLocalCabinReports[i].FlightId != null && existingLocalCabinReports[i].FlightId == flights[j].FlightId) || (existingLocalCabinReports[i].FlightAimsId != null && existingLocalCabinReports[i].FlightAimsId == flights[j].FlightAimsId)
                            ) {
                                for (var h = 0; h < flights[j].cabinReports.length; h++) {
                                    if (flights[j].cabinReports[h].AuthorAimsId == user.aimsId) {
                                        remove = true;
                                        deleted++;
                                    }

                                }
                            }
                        }
                    }
                }

                if (!remove)
                    finalLocalCabinReports.push(existingLocalCabinReports[i]);
            }

            // save the resulting local reports
            localStorageMD5Service.set('cabinReportLocalEdits', finalLocalCabinReports);

            return deleted;
        }

         /**
         * Deletes CrewMealRatings that are older than 20 days
         * @memberof DataCleanerFactory
         */
        function deleteOldCrewMealsRatings(){
            var res = GenericService.list("CrewMealRatings", objCallbackRatings);
            var lastDate = new Date();
            lastDate.setDate(lastDate.getDate() - 20);
            var crewMealIdsFiltered = res.filter(r => new Date(r.TimeStamp) >= lastDate);
            GenericService.saveOne(crewMealIdsFiltered,"CrewMealRatings");
        }

        /**
         * Deletes customer events whose flight doesn't exist
         */
        function deleteOrphanedCustomerEvents(){
            var flights = localStorageMD5Service.get('flights');
            var customerEvents = localStorageMD5Service.get('CustomerEvents');
            var finalCustomerEvents = [];

            if (customerEvents && flights && flights.length > 0){
                customerEvents.forEach(function(event){
                    //Search if event's flight exist
                    if(flights.find(x => x.FlightId == event.FlightId)){
                        finalCustomerEvents.push(event);
                    }
                });

                //save the resulting customer events
                localStorageMD5Service.set('CustomerEvents', finalCustomerEvents);
            }
        }

        function objCallbackRatings(){
            this.CrewMealId = null,
            this.TimeStamp = null
        }

        return service;
    }

})();